module.exports = __webpack_public_path__ + "img/search-sentosa.f5bb05ae.svg";